import axios from '../../axios'

/*
 * 省份历年数据统计管理接口
 */

// 创建省份统计
export const createProvincetj = (data) => {
    return axios({
        url: '/api/data/wish/provincestat',
        method: 'POST',
        data
    })
}

// 获取省份统计详情
export const getProvincetjInfo = (data) => {
    return axios({
        url: '/api/data/wish/provincestat/info',
        method: 'get',
        data
    })
}

// 修改更新省份统计
export const editProvincetj = (data) => {
    return axios({
        url: '/api/data/wish/provincestat',
        method: 'PUT',
        data
    })
}

// 删除省份统计信息
export const delProvincetj = (data) => {
    return axios({
        url: '/api/data/wish/provincestat',
        method: 'DELETE',
        data
    })
}

// 获取省份统计信息列表
export const getProvincetjList = (data) => {
    return axios({
        url: '/api/data/wish/provincestat',
        method: 'GET',
        data
    })
}

// 根据条件筛选并导出省份统计数据
export const exportProvinceData = (data) => {
    return axios({
        url: '/api/data/wish/provincestat/export',
        method: 'POST',
        data
    })
}

// 省份数据导入
export const importProvinceData = (data) => {
    return axios({
        url: '/api/data/wish/provincestat/import',
        method: 'POST',
        data
    })
}

// 省份数据批量更新
export const updataProvinceData = (data) => {
    return axios({
        url: '/api/data/wish/provincestat/batch/update',
        method: 'POST',
        data
    })
}

// 省份数据批量删除
export const queryDelProvinceData = (data) => {
    return axios({
        url: '/api/data/wish/provincestat/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/provincetj.js